import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logoTFFM.png'; // Importez le logo directement

const Logo = ({ className = '', imgClassName = '' }) => {
  return (
    <Link to="/" className={`flex items-center max-w-full ${className}`}>
      <img 
        src={logoImage}
        alt="Logo Verchamps" 
        className={`h-12 sm:h-14 md:h-16 w-auto max-w-full object-contain ${imgClassName}`}
      />
    </Link>
  );
};

export default Logo; 